import React from 'react';

const RodsInfo = () => {
  return (
    <div className="pop-up__content">
      <p className="pop-up__content-item">
        Do każdej kolumny otrzymujesz, w cenie szafy, drążek na ubrania. Jeżeli w którejś z kolumn
        nie potrzebujesz drążka, możesz go usunąć i w jego miejsce umieścić inne akcesorium.
        Niewykorzystane drążki możesz (tylko w szafach głębokich) umieścić jako dodatkowe w
        pozostałych kolumnach. Jeżeli nie wykorzystasz wszystkich drążków, które zostały
        przewidziane w standardzie, i tak otrzymasz je w przesyłce razem z szafą.
      </p>
    </div>
  );
};

export default RodsInfo;
